import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Theme from 'components/common/Theme/Theme'
import Media from 'components/common/Media'
import Mixin from 'components/common/Mixin'
import Link, { A } from 'components/common/Link/Link'
import Text from 'components/common/Text/Text'
import Icon from 'components/common/Icon/Icon'


const Locations = ({ stores = [], getPhoneNumber, getPhoneNumberUrl, handlePhoneLinkClick }) =>
  <React.Fragment>
    {
      stores.map(({
        address: {
          address1,
          city,
          zipcode,
          state,
          phoneNumber = {}
        },
        storeDetailsUrl
      }, index) =>
        <LocationDetails key={ index }>
          <Text bolder>{ address1 }<br />{ city } { state } { zipcode }</Text>
          <Media.Desktop>
            <PhoneNum>
              <Icon asset="phone" margin="0 4px 0 0" alt="" />
              { getPhoneNumber(phoneNumber) }
            </PhoneNum>
          </Media.Desktop>
          <Media.Mobile>
            <PhoneNumLink block href={ getPhoneNumberUrl(phoneNumber) } onClick={ handlePhoneLinkClick }>
              <Icon asset="phone" margin="0 4px 0 0" alt="" />
              { getPhoneNumber(phoneNumber) }
            </PhoneNumLink>
          </Media.Mobile>
          <StoreLink block to={ storeDetailsUrl }>Store Details</StoreLink>
        </LocationDetails>
      )
    }
  </React.Fragment>


Locations.propTypes = {
  getPhoneNumber: PropTypes.func,
  getPhoneNumberUrl: PropTypes.func,
  handlePhoneLinkClick: PropTypes.func,
  stores: PropTypes.arrayOf(PropTypes.object)
}

export default Locations

const LocationDetails = styled.div`
  position: relative;
  min-height: 138px;
  padding: 8px 15px 55px;
  overflow: hidden;
  line-height: 24px;
  vertical-align: top;
  background: ${Theme.colors.white};
  border: 1px solid ${Theme.colors.light_grey};
  ${Mixin.responsive('display', 'inline-block', 'block')}
  ${Mixin.responsive('width', '228px', '100%')}
  ${Media.desktop`
    margin: 0 22px 22px 0;
  `}
  ${Media.mobile`
    min-height: 114px;
    & + & {
      margin-top: 16px;
    }
  `}
`

const PhoneNumLink = styled(A)`
  position: absolute;
  bottom: 30px;
`

const PhoneNum = styled.div`
  position: absolute;
  bottom: 30px;
`

const StoreLink = styled(Link)`
  position: absolute;
  bottom: 8px;
  font-size: 12px;
`
